module.exports = __webpack_public_path__ + "media/images/distribution-section-d1f339163143106801575ccf2a1efcc6.jpg";